export default __webpack_public_path__ + "b81b255ffe0b68fb2f0fb44c6f6c779f.png";